import styled, { css } from 'styled-components';
import mediaQueries from '@Utils/shared/constants/mediaQueries';

export const Container = styled('a')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 10px 15px;
  border-radius: 6px;
  backdrop-filter: blur(4px);
  background-color: #9e9ea0;
  margin-top: 20px;
`;

const CommonWrapper = css`
  display: flex;
  margin: 25px 0 40px;
  padding: 15px 25px;
  border-radius: 6px;
  backdrop-filter: blur(4px);
  background-color: rgba(255, 255, 255, 0.85);

  @media ${mediaQueries.tablet} {
    display: flex;
    flex-direction: row;
    padding: 15px 30px 15px 15px;
    margin-bottom: 0;
  }

  @media ${mediaQueries.mobile} {
    display: flex;
    padding: 10px;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const Wrapper = styled('a')`
  ${CommonWrapper}
`;

export const WrapperMobile = styled.div`
  ${CommonWrapper}
`;

export const IconContainer = styled.div`
  display: flex;
  height: 70px;
  width: 70px;
  background: transparent;

  @media ${mediaQueries.tablet} {
    width: 60px;
    height: 60px;
    flex-shrink: 0;
    border-radius: 6px;
    box-shadow: 0 2px 20px -5px rgba(0, 0, 0, 0.5);
    margin-right: 15px;
  }

  @media ${mediaQueries.mobile} {
    width: 60px;
    height: 60px;
    margin-right: 15px;
    flex-shrink: 0;
  }
`;

export const IconElement = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
`;

export const SeoNickname = styled.div`
  margin-top: 25px;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  text-align: center;
  color: #f3f3f3;
  margin-bottom: 5px;

  @media ${mediaQueries.mobile} {
    margin-top: 16px;
  }
`;

export const SeoText = styled.div`
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.85);
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0;
  flex-shrink: 0;
  flex-grow: 2;

  @media ${mediaQueries.mobile} {
    align-self: center;
    margin-bottom: 10px;
    margin-left: 0;
    flex-shrink: 1;
  }
`;

export const GameTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  color: #2d2d30;
  user-select: text;
  text-transform: capitalize;
  margin-bottom: 0;
  letter-spacing: normal;
  text-align: left;
  margin-top: 5px;

  @media ${mediaQueries.tablet} {
    font-size: 18px;
    line-height: 25px;
    margin-bottom: 3px;
  }

  @media ${mediaQueries.mobile} {
    font-size: 18px;
    line-height: 25px;
    color: #000000;
  }
`;

export const GameGenre = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 5px;

  @media ${mediaQueries.tablet} {
    font-size: 15px;
    line-height: 20px;
    font-weight: 500;
    text-align: left;
    margin-top: 0;
    margin-bottom: 0;
  }

  @media ${mediaQueries.mobile} {
    text-align: left;
    opacity: 1;
    font-size: 15px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.7);
  }
`;

export const StoreLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 0 20px;
  border-radius: 0 0 6px 6px;

  @media ${mediaQueries.tablet} {
    padding: 0;
  }

  @media ${mediaQueries.mobile} {
    padding-left: 0;
    padding-top: 15px;
  }
`;

export const StoreLogo = styled.img`
  height: 38px;
`;

export const Store = styled.div`
  display: inline-flex;

  @media ${mediaQueries.desktop} {
    margin-left: 20px;
  }

  @media ${mediaQueries.tablet} {
    margin-left: 20px;
  }

  @media ${mediaQueries.mobile} {
    ${StoreLogo} {
      height: 48px;
    }
  }
`;
